"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.close = close;
exports.open = open;
exports.setOverlayProps = setOverlayProps;
var actionTypes = _interopRequireWildcard(require("./actionTypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * An action responsible for showing the overlay containing
 * the specified form.
 * @param {string} form
 */
function open(form) {
  return {
    type: actionTypes.OPEN,
    payload: {
      form: form
    }
  };
}

/**
 * An action responsible for hiding the overlay containing
 * the specified form.
 * @param {string} form
 */
function close(form) {
  return {
    type: actionTypes.CLOSE,
    payload: {
      form: form
    }
  };
}

/**
 * An action responsible for merging in the specified props
 * for the overlay containing the specified form.
 * @param {string} form
 * @param {object} props
 */
function setOverlayProps(form, props) {
  return {
    type: actionTypes.SET_OVERLAY_PROPS,
    payload: {
      form: form,
      props: props
    }
  };
}